<template>
    <div class="fill-height bg_auth" style="width=100%">
        <v-layout wrap class="login">
            <center :class="!$vuetify.display.mobile ? 'login_card' : 'login_card_mobile'">
                <v-flex xs12 class="text-center">
                    <img
                        src="/img/bobbee_logo_3.png"
                        :height="!$vuetify.display.mobile ? '100vh' : ''"
                        :width="!$vuetify.display.mobile ? '' : '200vw'"
                    />
                </v-flex>
                <v-flex v-if="user && activeToken" xs6 class="align-center">
                    <!-- <v-flex xs12 class="oss-password-recovery align-center"> -->
                    <h3>Réinitialiser votre mot de passe</h3>
                    <v-form ref="form" v-model="valid">
                        <v-text-field
                            rounded
                            required
                            type="password"
                            :rules="[
                                () => password.length > 0 || 'empty password',
                                () =>
                                    password === pwdConfirmation ||
                                    !pwdConfirmation.length > 0 ||
                                    'Passwords does not match',
                            ]"
                            @keyup.enter="resetPassword"
                            placeholder="Nouveau mot de passe"
                            v-model="password"
                        />
                        <v-text-field
                            rounded
                            required
                            type="password"
                            :rules="[
                                () => pwdConfirmation.length > 0 || 'empty password',
                                () =>
                                    password === pwdConfirmation ||
                                    !password.length > 0 ||
                                    'Passwords does not match',
                            ]"
                            @keyup.enter="resetPassword"
                            placeholder="Confirmer votre mot de passe"
                            v-model="pwdConfirmation"
                        />
                        <v-btn
                            rounded
                            color="primary"
                            width="80%"
                            elevation="0"
                            @click="resetPassword"
                            size="small"
                            >Modifier</v-btn
                        >
                    </v-form>
                    <v-alert type="success" :model-value="isPasswordModified"
                        >Votre mot de passe a bien été modifié <br /><router-link :to="'/login'"
                            >Se connecter</router-link
                        >
                    </v-alert>
                </v-flex>
                <v-flex v-else-if="user">
                    <p>Le lien de reinitialisation a expiré</p>
                    <router-link :to="'/login'">Retourner à la page de connection</router-link>
                </v-flex>
            </center>
        </v-layout>
    </div>
</template>
<script lang="ts">
import gql from "graphql-tag";
import moment from "moment-timezone";
import { User } from "../../../../types";
import { Apollo } from "@/decorators";
import UPDATE_USER_PASSWORD from "../../graphql/user/UpdateUserPassword.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component
export class ResetPassword extends Vue {
    password: string = "";

    pwdConfirmation: string = "";
    loading = false;

    valid = false;

    isPasswordModified = false;

    get token() {
        return this.$route.params.token;
    }

    get activeToken() {
        return this.user ? moment().isBefore(moment(this.user.tokenExpirationDate)) : false;
    }

    @Apollo({
        query: gql`
            query AssociatedUser($token: String!) {
                user(where: { resetPasswordToken: $token }) {
                    id
                    email
                    tokenExpirationDate
                }
            }
        `,
        variables() {
            return {
                token: this.token,
            };
        },
        skip() {
            return this.user;
        },
    })
    user: User = null;

    resetPassword() {
        // @ts-ignore
        if (!this.$refs.form.validate()) return;
        this.loading = true;
        this.$apollo.mutate({
            mutation: UPDATE_USER_PASSWORD,
            variables: {
                userId: this.user.id,
                password: this.password,
            },
            update: (data) => {
                this.isPasswordModified = true;
            },
        });
        this.loading = false;
    }
}

export default toNative(ResetPassword);
</script>
<style scoped>
.background_image {
    background-color: #f9b12a !important;
}
.bg_auth {
    height: "100%";
    display: flex;
    flex-direction: column;
    justify-content: right;
    background-image: url("../../assets/img/bg_auth.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position-x: center;
}
</style>
